import { Button, Col, Form, Modal, Row } from 'antd';
import React, { useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import CheckboxComponent from 'components/atoms/CheckboxComponent';
import InputComponent from 'components/atoms/InputComponent';
import InputNumberComponent from 'components/atoms/InputNumberComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';
import PrilohyTable from 'components/molecules/Dokumenty/PrilohyTable';
import FormWrapper from 'components/molecules/FormWrapper';

import { EOmezPrevodVyjadreni, IOmPrevod, omDetailGet } from 'services/dokumenty/omezPrevoditelnost';
import { IDokOmezPrevod, dokOmezPrevodPrikazGet, dokOmezPrevodPrikazPut } from 'services/dokumenty/prikazy';
import { ISmlouvniStrany, dokumentOsobyApi } from 'services/dokumenty/smlouva';

import Osoby from '../Osoby';
import Podpisy from '../Podpisy';

interface IOmezenaPrevodFirstStep {
    nextStep: () => void;
    zadostID: number;
    prikazyData: ISmlouvniStrany;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    setData: React.Dispatch<React.SetStateAction<IDokOmezPrevod | undefined>>;
    data?: IDokOmezPrevod;
    omData?: IOmPrevod;
    signingDisabled: boolean;
}

const OmezenaPrevodFirstStep: React.FC<IOmezenaPrevodFirstStep> = ({
    nextStep,
    zadostID,
    prikazyData,
    setData,
    data,
    omData,
    setLoading,
    signingDisabled
}) => {
    const [form] = Form.useForm();

    return (
        <>
            {data && prikazyData && omData && (
                <FormWrapper
                    outForm={form}
                    onFinish={values => {
                        setLoading(true);

                        const dataToSend = {
                            ...data,
                            idomezprevod: data.idomezprevod,
                            idomprevod: data.idomprevod,
                            vyjadreni: values.vyjadreni
                        };

                        setData(dataToSend);
                        dokOmezPrevodPrikazPut(zadostID, dataToSend)
                            .then(() => nextStep())
                            .finally(() => setLoading(false));
                    }}
                >
                    <Title text="EMITENT" level={5} />
                    <InputComponent
                        disabled={true}
                        initialValue={prikazyData?.spolecnost.idmb}
                        label="IDENTIFIKACNI_CISLO"
                        name="idmbSpolecnost"
                        notRequired={true}
                    />
                    {prikazyData?.spolecnost.dicdph && (
                        <InputComponent
                            disabled={true}
                            initialValue={prikazyData?.spolecnost.dicdph}
                            label="ISIN_IDENTIFIKACE_DIC"
                            name="dicdphSpolecnost"
                            notRequired={true}
                        />
                    )}
                    <InputComponent
                        disabled={true}
                        initialValue={prikazyData?.spolecnost.nazev}
                        label="ISIN_IDENTIFIKACE_FIRMA"
                        name="nazevSpolecnost"
                        notRequired={true}
                    />
                    <InputComponent
                        disabled={true}
                        initialValue={prikazyData?.spolecnost.lei}
                        label="LEI_CELE"
                        name="leiSpolecnost"
                        notRequired={true}
                    />
                    <InputComponent
                        name="isin"
                        label={'ISIN'}
                        initialValue={omData?.isin}
                        disabled={true}
                        notRequired={true}
                    />
                    <InputNumberComponent
                        disabled={true}
                        initialValue={prikazyData?.spolecnost.idmb}
                        label="OM_POCET_CP"
                        name="idmbSpolecnost"
                        notRequired={true}
                    />
                    <Title text="PRODAVAJICI" level={5} />
                    <InputComponent
                        name="alinearidProdavajici"
                        label="CISLO_MAJETKOVEHO_UCTU"
                        initialValue={omData?.prevodce.alinearid}
                        disabled={true}
                    />
                    <InputComponent
                        name="jmenoProdavajici"
                        label="NAZEV_JMENO"
                        initialValue={[omData?.prevodce.ttma, omData?.prevodce.jmma, omData?.prevodce.pjma]
                            .filter(Boolean)
                            .join(' ')}
                        disabled={true}
                    />
                    <Title text="KUPUJICI" level={5} />
                    <InputComponent
                        name="alinearidKupujici"
                        label="CISLO_MAJETKOVEHO_UCTU"
                        initialValue={omData?.nabyvatel.alinearid}
                        disabled={true}
                    />
                    <InputComponent
                        name="jmenoKupujici"
                        label="NAZEV_JMENO"
                        initialValue={[omData?.nabyvatel.ttma, omData?.nabyvatel.jmma, omData?.nabyvatel.pjma]
                            .filter(Boolean)
                            .join(' ')}
                        disabled={true}
                    />

                    <SelectComponent
                        name="vyjadreni"
                        labelParagraph={'OM_ROZHODNUTI_VYJADRENI'}
                        defaultValue={data?.vyjadreni}
                        data={[
                            {
                                labelcz: 'OM_ROZHODNUTI_SOUHLAS',
                                value: EOmezPrevodVyjadreni.SOUHLAS
                            },
                            {
                                labelcz: 'OM_ROZHODNUTI_NESOUHLAS',
                                value: EOmezPrevodVyjadreni.NESOUHLAS
                            }
                        ]}
                        isFormItem={true}
                        disabled={signingDisabled}
                    />

                    <PrilohyTable
                        required={true}
                        zadostID={zadostID}
                        disabled={signingDisabled}
                        // titleTooltip="PRIKAZ_PREVODNASL_MAJETKOV_PRILOHY_TOOLTIP"
                    />

                    <Row className="button-row">
                        <Col>
                            <ButtonComponent buttontext="POKRACOVAT" id="isinPokracovatBtn" htmlType="submit" />
                        </Col>
                    </Row>
                </FormWrapper>
            )}
        </>
    );
};

interface IOmezPrevodPodminky {
    nextStep: () => void;
    prevStep: () => void;
    signingDisabled: boolean;
    data: IDokOmezPrevod;
    setData: React.Dispatch<React.SetStateAction<IDokOmezPrevod | undefined>>;
    zadostID: number;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const OmezPrevodPodminky: React.FC<IOmezPrevodPodminky> = ({
    nextStep,
    prevStep,
    signingDisabled,
    data,
    setData,
    zadostID,
    setLoading
}) => {
    const [isChecked, setIsChecked] = useState<boolean>(signingDisabled);
    const [form] = Form.useForm();

    return (
        <FormWrapper outForm={form} onFinish={() => {}}>
            <Paragraph
                text="OM_PRIKAZ_SOUHLAS1"
                style={{
                    display: 'block',
                    marginTop: 16
                }}
            />
            <Paragraph
                text="OM_PRIKAZ_SOUHLAS2"
                style={{
                    display: 'block'
                }}
            />
            <Row
                style={{
                    marginBottom: 4,
                    marginTop: 26
                }}
            >
                <CheckboxComponent
                    name="souhlas"
                    checkboxText={<TranslateText>POTVRZENI_CHECKBOX</TranslateText>}
                    onChange={() => setIsChecked(pv => !pv)}
                    disabled={signingDisabled}
                    checked={isChecked}
                    defaultChecked={isChecked}
                />
            </Row>
            <Row className="button-row">
                <ButtonComponent buttontext="ZPET" type="default" onClick={() => prevStep()} id="isinZpetBtn" />
                <ButtonComponent
                    buttontext="POKRACOVAT"
                    onClick={() => {
                        nextStep();

                        if (!data.souhlas) {
                            dokOmezPrevodPrikazPut(zadostID, {
                                ...data,
                                souhlas: true
                            })
                                .then(() => {
                                    nextStep();
                                    setData({
                                        ...data,
                                        souhlas: true
                                    });
                                })
                                .finally(() => setLoading(false));
                        }
                    }}
                    id="isinPokracovatBtn"
                    disabled={!isChecked}
                />
            </Row>
        </FormWrapper>
    );
};

interface IOmezPrevod {
    zadostID: number;
    prikazyData: ISmlouvniStrany;
}

const OmezenaPrevod: React.FC<IOmezPrevod> = ({ zadostID, prikazyData }) => {
    const { confirm } = Modal;
    const [currentStep, setCurrentStep] = useState<number>(0);
    const [data, setData] = useState<IDokOmezPrevod>();
    const [omData, setOmData] = useState<IOmPrevod>();
    const [loading, setLoading] = useState<boolean>(false);
    const signingDisabled = !!data?.souhlas;

    useEffect(() => {
        setLoading(true);
        dokOmezPrevodPrikazGet(zadostID)
            .then(resp => {
                dokumentOsobyApi(zadostID, true)
                    .then(response => response.osoby.some(e => !!e.podepsano) && setCurrentStep(3))
                    .finally(() => setLoading(false));
                omDetailGet(resp.idomprevod).then(detailResp => setOmData(detailResp));
                setData(resp);
            })
            .catch(() => {
                setData({} as IDokOmezPrevod);
                setLoading(false);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zadostID]);

    const next = () => {
        window.scrollTo(0, 0);
        setCurrentStep(currentStep + 1);
    };

    const prev = () => {
        window.scrollTo(0, 0);
        setCurrentStep(currentStep - 1);
    };

    const steps = [
        {
            title: '',
            content: (
                <OmezenaPrevodFirstStep
                    nextStep={next}
                    zadostID={zadostID!}
                    prikazyData={prikazyData}
                    data={data}
                    omData={omData}
                    setData={setData}
                    setLoading={setLoading}
                    signingDisabled={signingDisabled}
                />
            )
        },
        {
            title: 'DOKUMENT_DODATEK_SHRNUTI_TITLE',
            content: (
                <OmezPrevodPodminky
                    nextStep={next}
                    prevStep={prev}
                    signingDisabled={signingDisabled}
                    data={data!}
                    setData={setData}
                    setLoading={setLoading}
                    zadostID={zadostID}
                />
            )
        },
        {
            title: '',
            content: <Osoby nextStep={next} prevStep={prev} zadostID={zadostID!} isDodatek={false} />
        },
        {
            title: '',
            content: <Podpisy prevStep={prev} zadostID={zadostID!} showPreControl={false} isPrikaz={true} />
        }
    ];
    return (
        <LoadingWrapper loading={loading}>
            {steps.length - 3 > currentStep && data?.souhlas && (
                <Button
                    style={{
                        top: '30%',
                        right: 10,
                        position: 'fixed',
                        zIndex: 999
                    }}
                    type="primary"
                    onClick={() =>
                        confirm({
                            title: <TranslateText>DOKUMENTY_OSOBY_ZMENIT</TranslateText>,
                            cancelText: <TranslateText>NE</TranslateText>,
                            okText: <TranslateText>ANO</TranslateText>,
                            onOk() {
                                setLoading(true);
                                dokOmezPrevodPrikazPut(zadostID!, {
                                    idomprevod: data.idomprevod,
                                    vyjadreni: data.vyjadreni,
                                    souhlas: false
                                })
                                    .then(() => {
                                        setData({
                                            ...data!,
                                            souhlas: false
                                        });
                                    })
                                    .finally(() => setLoading(false));
                            }
                        })
                    }
                >
                    <TranslateText>POVOLIT_EDITACI</TranslateText>
                </Button>
            )}
            <Row gutter={8}>
                <Col span={24}>{steps[currentStep].content}</Col>
            </Row>
        </LoadingWrapper>
    );
};

export default OmezenaPrevod;
